// @todo enable the following disabled rules see OPENTOK-31136 for more info
/* eslint-disable no-underscore-dangle */

const OTHelpers = require('../common-js-helpers/OTHelpers.js');
const StaticConfig = require('../helpers/StaticConfig.js')();

const staticConfig = StaticConfig.onlyLocal();

const logging = {};
module.exports = logging;

OTHelpers.useLogHelpers(logging);

let _debugHeaderLogged = false;
const _setLogLevel = logging.setLogLevel;

// On the first time log level is set to DEBUG (or higher) show version info.
logging.setLogLevel = function (level) {
  // Set OTHelpers to the same log level
  OTHelpers.setLogLevel(level);
  const retVal = _setLogLevel.call(logging, level);

  if (!_debugHeaderLogged) {
    logging.debug(`OpenTok JavaScript library ${staticConfig.version}`);
    logging.debug(`Release notes: ${staticConfig.websiteUrl
    }/opentok/webrtc/docs/js/release-notes.html`);
    logging.debug(`Known issues: ${staticConfig.websiteUrl
    }/opentok/webrtc/docs/js/release-notes.html#knownIssues`);
    _debugHeaderLogged = true;
  }

  logging.debug(`OT.setLogLevel(${retVal})`);
  return retVal;
};

logging.setLogLevel(staticConfig.debug ? logging.DEBUG : logging.WARN);

// TODO: these methods need to be re-exposed for public use on OT :-(

/**
  * Sets the API log level.
  * <p>
  * Calling <code>OT.setLogLevel()</code> sets the log level for runtime log messages that
  * are the OpenTok library generates. The default value for the log level is
  * <code>OT.ERROR</code>.
  * </p>
  * <p>
  * The OpenTok JavaScript library displays log messages in the debugger console (such as
  * Firebug), if one exists.
  * </p>
  * <p>
  * The following example logs the session ID to the console, by calling <code>OT.log()</code>.
  * The code also logs an error message when it attempts to publish a stream before you have
  * connected to the session (by calling <code>Session.connect()</code>).
  * </p>
  * <pre>
  * OT.setLogLevel(OT.LOG);
  * session = OT.initSession(sessionId);
  * OT.log(sessionId);
  * publisher = OT.initPublisher("publishContainer");
  * session.publish(publisher);
  * </pre>
  *
  * @param {Number} logLevel The degree of logging desired by the developer:
  *
  * <p>
  * <ul>
  *   <li>
  *     <code>OT.NONE</code> &#151; API logging is disabled.
  *   </li>
  *   <li>
  *     <code>OT.ERROR</code> &#151; Logging of errors only.
  *   </li>
  *   <li>
  *     <code>OT.WARN</code> &#151; Logging of warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.INFO</code> &#151; Logging of other useful information, in addition to
  *     warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.LOG</code> &#151; Logging of <code>OT.log()</code> messages, in addition
  *     to OpenTok info, warning,
  *     and error messages.
  *   </li>
  *   <li>
  *     <code>OT.DEBUG</code> &#151; Fine-grained logging of all API actions, as well as
  *     <code>OT.log()</code> messages.
  *   </li>
  * </ul>
  * </p>
  *
  * @name OT.setLogLevel
  * @memberof OT
  * @function
  * @see <a href="#log">OT.log()</a>
  */

/**
  * Sends a string to the debugger console. However, the function only logs to the console
  * if you have set the log level to <code>OT.LOG</code> or <code>OT.DEBUG</code>,
  * by calling <code>OT.setLogLevel(OT.LOG)</code> or <code>OT.setLogLevel(OT.DEBUG)</code>.
  *
  * @param {String} message The string to log.
  *
  * @name OT.log
  * @memberof OT
  * @function
  * @see <a href="#setLogLevel">OT.setLogLevel()</a>
  */



// WEBPACK FOOTER //
// ./src/js/ot/logging.js